import React, { useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import './QuestionCheckboxMulti.css'

const QuestionCheckboxMulti = ({ options, callback, currentAnswer }) => {
  const [ checkboxes, setCheckboxes ] = useState(options.groups || []);

  const handleClick = (e) => {
    const name = e.target.name;
    const checkStatus = e.target.checked;
    const value = e.target.value;
    const CheckFiltered = checkboxes.map( (o) => {     
      if(o.title === name) {
        o.options.map( (c) => {
          if(c.option === value)
            c.checked = checkStatus;
          return c;
        });
      }
      return o;
    });

    setCheckboxes(CheckFiltered);
    callback(checkboxes);
  }

  // const handleNext = (e) => {
  //   callback(checkboxes);
  // }

  return (
    <>
      {checkboxes ? checkboxes.map( (item) => {
        return (
          <>
            <div className="text-center">
            <h3 className="text-base sm:text-2xl font-bold mb-5 sm:mb-11" key={uuidv4()} >{ item.title }</h3>
              {item.options.map( (o) => (
                
                <div className={"inline-block relative pb-10 sm:px-6 form-group w-full sm:w-auto"} key={uuidv4()}>
                  <input
                    onClick={handleClick}
                    className="option"
                    key={uuidv4()}
                    type='checkbox'
                    defaultChecked={o.checked}
                    name={item.title}
                    value={o.option}
                    id={item.title + '-' + o.option}
                  />
                  <label
                    className="text-base sm:text-2xl font-medium relative"
                    htmlFor={item.title + '-' + o.option}>
                      {o.option}
                  </label>
                </div>
              ))}
            </div>
          </>
        )
      }):null}
    </>
  );
};

export default QuestionCheckboxMulti;
